import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    dashboardTab: "campaignAnalytics"
} 

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashBoardStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
        clearDashboard(action, state) {
            return initialState
        },
    }
})

export const dashboardActions = dashboardSlice.actions;
export default dashboardSlice;